/**
 * Suspense fallback shown while a lazily-loaded page chunk arrives. Small,
 * quiet, and announced to assistive tech via role="status".
 */
export function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      <span className="label">Loading</span>
    </div>
  );
}
